'use strict';

var util = require('./util.cjs.js');
var System_v1alpha1_schema = require('../schema/kinds/System.v1alpha1.schema.json.cjs.js');

const systemEntityV1alpha1Validator = util.ajvCompiledJsonSchemaValidator(System_v1alpha1_schema.default);

exports.systemEntityV1alpha1Validator = systemEntityV1alpha1Validator;
//# sourceMappingURL=SystemEntityV1alpha1.cjs.js.map
